import React from 'react';

import Icon from '../Icon/Icon';

const CommentIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M39.7111 22.5C41.9202 22.5 43.7111 24.2909 43.7111 26.5V39.602C43.7111 41.8112 41.9202 43.602 39.7111 43.602H21.538L14.851 50.1641C14.2224 50.7809 13.1611 50.3428 13.1507 49.4622L13.0814 43.602H12C9.79086 43.602 8 41.8111 8 39.602V26.5C8 24.2909 9.79086 22.5 12 22.5H39.7111Z'
                fill='#00D1D2'
            />
            <path
                d='M18 12.5C15.7909 12.5 14 14.2909 14 16.5V34.8339C14 37.0563 15.8115 38.8526 18.0338 38.8338L38.2975 38.6625L47.5141 46.2841C49.016 47.5261 51.2873 46.4764 51.3147 44.5277L51.3985 38.5518L53.3682 38.5352C55.564 38.5166 57.3344 36.7313 57.3344 34.5353V16.5C57.3344 14.2909 55.5435 12.5 53.3344 12.5H18Z'
                fill='#393E44'
                stroke='#FFFDFB'
                strokeWidth='2.5'
            />
            <path
                d='M38.0232 25.5954C38.0232 27.1562 36.7579 28.4215 35.1971 28.4215C33.6362 28.4215 32.3709 27.1562 32.3709 25.5954C32.3709 24.0346 33.6362 22.7692 35.1971 22.7692C36.7579 22.7692 38.0232 24.0346 38.0232 25.5954Z'
                fill='#FFFDFB'
            />
            <path
                d='M45.5597 25.5954C45.5597 27.1562 44.2943 28.4215 42.7335 28.4215C41.1727 28.4215 39.9073 27.1562 39.9073 25.5954C39.9073 24.0346 41.1727 22.7692 42.7335 22.7692C44.2943 22.7692 45.5597 24.0346 45.5597 25.5954Z'
                fill='#FFFDFB'
            />
            <path
                d='M30.4868 25.5953C30.4868 27.1562 29.2215 28.4215 27.6606 28.4215C26.0998 28.4215 24.8345 27.1562 24.8345 25.5953C24.8345 24.0345 26.0998 22.7692 27.6606 22.7692C29.2215 22.7692 30.4868 24.0345 30.4868 25.5953Z'
                fill='#FFFDFB'
            />
        </Icon>
    );
};

export default CommentIcon;
